import {
    List,
    EditButton,
    Datagrid,
    TextField,
    ShowButton,
    useRecordContext,
    Filter,
    TextInput,
    SelectInput,
} from 'react-admin';
import ThumbnailField from '../../common/ThumbnailField';
import FormattedDateTimeField from '../../common/FormattedDateTimeField';
import { format } from 'date-fns';
import { STATUSES } from '../../common/constants';
import StatusTags from '../../common/StatusTags';
import useIsPermission from '../../hooks/useIsPermission';
import PermissionBasedActions from '../../common/PermissionBasedActionsButton';
import ClearFiltersOnRouteChange from '../../common/ClearFiltersOnRouteChange';
import ConfirmDeleteButton from '../../common/ConfirmDeleteButton';
import { BatchesTemplateAutoComplete } from '../../common/inputs/autoCompleteInputs/BatchTemplateAutoComplete';

const Actions = () => {
    const { isDeletable, isUpdatable } = useIsPermission('BATCH');
    return (
        <div className={'flex gap-2'}>
            <ShowButton />
            {isUpdatable && <EditButton />}
            {isDeletable && <ConfirmDeleteButton />}
        </div>
    );
};

Actions.defaultProps = {
    label: 'Actions',
};

const FormattedRegistrationField = (props: any) => {
    const record = useRecordContext<any>();
    return (
        record && (
            <div className={'flex flex-col text-sm space-y-1'}>
                {record.registrationStartDate && (
                    <div className={'flex items-center space-x-2'}>
                        <div className={'whitespace-nowrap'}>
                            {format(new Date(record.registrationStartDate), 'dd/MM/yyyy hh:mm a')}
                        </div>
                    </div>
                )}
                {record.registrationEndDate && (
                    <div className={'flex items-center  space-x-2'}>
                        <div className={'whitespace-nowrap'}>
                            {format(new Date(record.registrationEndDate), 'dd/MM/yyyy hh:mm a')}
                        </div>
                    </div>
                )}
            </div>
        )
    );
};

FormattedRegistrationField.defaultProps = {
    source: 'registrationStartDate',
    label: 'Registration',
};

export const FormattedStartEndField = (props: any) => {
    const record = useRecordContext<any>();
    return record ? (
        <div className={'flex flex-col text-sm space-y-1'}>
            {record.startTime && (
                <div className={'flex items-center space-x-2'}>
                    <div className={'whitespace-nowrap'}>
                        {format(new Date(record.startTime), 'dd/MM/yyyy hh:mm a')}
                    </div>
                </div>
            )}
            {record.endTime && (
                <div className={'flex items-center  space-x-2'}>
                    <div className={'whitespace-nowrap'}>
                        {format(new Date(record.endTime), 'dd/MM/yyyy hh:mm a')}
                    </div>
                </div>
            )}
        </div>
    ) : null;
};

FormattedStartEndField.defaultProps = {
    source: 'startTime',
    label: 'Start - End',
};
const ListFilter = (props: any) => (
    <Filter {...props}>
        <TextInput label="Search" source="title" alwaysOn />
        <SelectInput source="status" label={'Status'} fullWidth alwaysOn choices={STATUSES} />
        <BatchesTemplateAutoComplete alwaysOn />
    </Filter>
);
const BatchesList = () => {
    const { isWritable } = useIsPermission('BATCH');

    return (
        <List
            filters={<ListFilter />}
            actions={<PermissionBasedActions isWritable={isWritable} />}
            queryOptions={{
                refetchOnWindowFocus: false,
                refetchOnReconnect: false,
            }}
        >
            <ClearFiltersOnRouteChange />
            <Datagrid bulkActionButtons={false}>
                <ThumbnailField source="image" />
                <TextField source="title" />
                <TextField source="displayOrder" />
                <StatusTags source="status" label={'Status'} />
                <FormattedStartEndField source="startTime" />
                <FormattedRegistrationField source="registrationStartDate" />
                <FormattedDateTimeField source="createdAt" />
                <Actions />
            </Datagrid>
        </List>
    );
};
export default BatchesList;
